import { ClientRequestItemFileReference } from '@aiwyn/api';
import { FileModel, FileSource } from '@aiwyn/shared';

export interface ReferenceFilePreviewList {
  files: FileModel[];
  initialIndex: number;
}

export function buildReferenceFilePreviewList(
  refs: ClientRequestItemFileReference[],
  clicked: ClientRequestItemFileReference,
): ReferenceFilePreviewList {
  const files = refs.map((ref) => ({
    id: ref.fileId,
    fileSource: FileSource.CLIENT_REQUEST,
    name: ref.file.name,
    dmsFileId: ref.file.dmsId ?? ref.file.dmsFileId,
  }));
  const initialIndex = Math.max(
    0,
    refs.findIndex((ref) => ref.id === clicked.id),
  );
  return { files, initialIndex };
}
